import { format } from 'date-fns';
import { getDateString } from '../../../../utils/filters/getDateString';
import { TIME_API_FORMAT } from '../../../../constants';

export const getApiStringFromDateAndTime = (
  date: Date,
  time: Date,
  allowTime: boolean
) => {
  let apiString = getDateString(date);
  if (allowTime) {
    apiString = `${apiString}T${format(time, TIME_API_FORMAT)}`;
  }
  return apiString;
};
